import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import useMarketShareHooks from 'src/components/AtlasV2Components/Hooks/useMarketShareRequestHook';
import { METRICTYPE } from 'src/utils/entityDefinitions';

/**
 *
 * Share of Organic Traffic
 */
const AtlasV2OrganicTrafficSplineChart = () => {
  const { requestBuilder, marketShareBuilder } = useMarketShareHooks();
  return (
    <AtlasV2ComparableSplineChart
      indexName="traffic"
      fieldName="organicClicks"
      requestBuilder={requestBuilder}
      marketShareBuilder={marketShareBuilder}
      metricTypeDisplay={METRICTYPE.PERCENT}
      title="Share of Organic Traffic"
    />
  );
};

export default AtlasV2OrganicTrafficSplineChart;
